<template>
  <el-dialog custom-class="dialog-modal-permission" :model-value="flagVisible" width="770px" :before-close="handleClose">
    <div class="modal-permission">
      <div class="modal-p-content text-that-needs-wrapping">
        <div class="modal-p-title">
          <h1>1</h1>
        </div>
        <div class="modal-p-title">
          <span>Select products for this Player’s Product Library</span>
        </div>
        <div class="modal-p-desc">
          <p>By default, all your in-category products are available in your Player. But, you are welcome to customize your product collection for a specific Player instance. You can even add products outside your brand for comparison if included in your subscription.</p>
        </div>
        <div class="modal-p-img">
          <img src="@/assets/images/permissions/player_products.png" alt="" />
        </div>
      </div>
      <div class="modal-p-content">
        <div class="modal-p-title">
          <h1>2</h1>
        </div>
        <div class="modal-p-title">
          <span>Choose featured products to load by default in this Player</span>
        </div>
        <div class="modal-p-desc">
          <p>Once you’ve selected the products available in this Player instance, choose up to three products to feature in the Product Player area.</p>
        </div>
        <div class="modal-p-img" style="margin-top:75px;">
          <img src="@/assets/images/permissions/player.png" alt="" />
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    flagVisible: Boolean
  },
  emits: ['closeModal'],
  data: function () {
    return {
    }
  },
  created: function () {
  },
  watch: {
  },
  methods: {
    handleClose: function () {
      this.$emit('closeModal')
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-p-content {
  .modal-p-img {
    img {
      width: 320px;
    }
  }
}
</style>
